import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { version } from '../../../../package.json';

@Injectable()
export class AssetsCacheBusterInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith("./assets/")) {
      req = req.clone({
        // Prevent caching in IE, in particular IE11.
        // See: https://support.microsoft.com/en-us/help/234067/how-to-prevent-caching-in-internet-explorer
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        },
        setParams: {
          ["v"]: version
        }
      });
    }
    return next.handle(req);
  }
}
